import React, { Suspense, useState } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Home';
import Contact from './Contact';
import Menu from './components/Menu'
import Footer from './components/Footer';

function App() {


  const [lang, setLang] = useState(localStorage.getItem("lang_code_medinlab")? localStorage.getItem("lang_code_medinlab") : "fr");

  const onChangeLang = (e) => {

    const lang_code = e.target.value;
    if(lang_code ===  "fr"){
      console.log('lang_code',lang_code)
      setLang(lang_code)
      localStorage.setItem("lang_code_medinlab", lang_code)
     }
  else if(lang_code ===  "en"){
    console.log('lang_code',lang_code)
     setLang(lang_code)
     localStorage.setItem("lang_code_medinlab", lang_code)
    }

  }


  return (
    <Suspense fallback='loading'>
    <BrowserRouter>
       <Menu ChangeLang={(data)=>onChangeLang(data)} translation={lang}/>
      <Routes>
        <Route path="/" element={<Home translation={lang}/>} />
        <Route path="/contact" element={<Contact translation={lang}/>} />
      </Routes>
      <Footer translation={lang}/>
    </BrowserRouter>
      </Suspense>

    
  );
}

export default App;
